import { registerModuleDataProvider } from '../../providers/CustomDataProvider';
import { Resources } from '../resource';
import { perpsV1PresetsDataProvider } from './dataProvider';

// 注册 perps-v1-presets 模块的数据提供者
export function initPerpsV1PresetsDataProvider() {
  registerModuleDataProvider(Resources.perpsV1Presets, perpsV1PresetsDataProvider);
}

// 自动初始化
initPerpsV1PresetsDataProvider();
